import { render, staticRenderFns } from "./payslipcontent.vue?vue&type=template&id=44b0e420"
import script from "./payslipcontent.vue?vue&type=script&lang=js"
export * from "./payslipcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports